var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25,
    viewBox: "0 0 30.14 11.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9300;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.31,.7c.89,.47,1.57,1.13,2.06,1.98,.49,.85,.73,1.83,.73,2.94s-.24,2.08-.73,2.93c-.49,.85-1.17,1.52-2.06,1.98-.89,.47-1.92,.7-3.1,.7H0V0H4.21c1.18,0,2.22,.24,3.1,.7Zm-.86,7.31c.58-.57,.86-1.37,.86-2.4s-.29-1.84-.86-2.42-1.38-.86-2.42-.86h-1.3v6.53h1.3c1.03,0,1.84-.28,2.42-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.94,.7c.89,.47,1.57,1.13,2.06,1.98,.48,.85,.73,1.83,.73,2.94s-.24,2.08-.73,2.93c-.49,.85-1.17,1.52-2.06,1.98-.89,.47-1.92,.7-3.1,.7h-4.21V0h4.21c1.18,0,2.22,.24,3.1,.7Zm-.86,7.31c.58-.57,.86-1.37,.86-2.4s-.29-1.84-.86-2.42-1.38-.86-2.42-.86h-1.3v6.53h1.3c1.03,0,1.84-.28,2.42-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,2.19v2.27h3.66v2.11h-3.66v2.46h4.14v2.19h-6.88V0h6.88V2.19h-4.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDde);
export default __webpack_public_path__ + "static/media/dde.b63326cecdfc2e996554b2acb5614b87.svg";
export { ForwardRef as ReactComponent };